import { View } from './view'

export const Smi = View
